import React from "react";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between mb-6 pb-5 border-b border-[#E5E7EB]" data-testid="page-header">
      <div>
        <div className="text-[11px] uppercase tracking-[0.15em] text-[#C1121F] font-semibold mb-1">Singh Offset</div>
        <h1 className="font-display text-3xl font-bold text-[#0F172A] tracking-tight">{title}</h1>
        {subtitle && <p className="text-[#475569] text-sm mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatusBadge({ status }) {
  const cls = `badge badge-${status}`;
  return <span className={cls}>{status}</span>;
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="border-2 border-dashed border-[#E5E7EB] rounded-lg py-16 px-6 text-center" data-testid="empty-state">
      {Icon && (
        <div className="inline-flex w-14 h-14 rounded-full bg-[#FEF2F2] items-center justify-center mb-3">
          <Icon size={26} className="text-[#C1121F]" strokeWidth={1.5} />
        </div>
      )}
      <div className="font-display font-semibold text-lg text-[#0F172A]">{title}</div>
      {hint && <div className="text-sm text-[#475569] mt-1 max-w-sm mx-auto">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Modal({ open, onClose, title, children, maxWidth = "max-w-lg" }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="modal">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative bg-white rounded-lg shadow-xl w-full ${maxWidth} max-h-[90vh] overflow-hidden flex flex-col`}>
        <div className="px-6 py-4 border-b border-[#E5E7EB] flex items-center justify-between">
          <h3 className="font-display font-bold text-lg">{title}</h3>
          <button onClick={onClose} data-testid="modal-close" className="text-[#94A3B8] hover:text-[#0F172A] text-xl leading-none">×</button>
        </div>
        <div className="p-6 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children, required }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-wider font-semibold text-[#475569] mb-1.5 block">
        {label}{required && <span className="text-[#C1121F] ml-1">*</span>}
      </label>
      {children}
    </div>
  );
}

export function Button({ children, variant = "primary", className = "", ...props }) {
  const base = "px-4 py-2 rounded font-semibold text-sm flex items-center gap-2 transition-all";
  const variants = {
    primary: "btn-primary",
    secondary: "bg-white border border-[#E5E7EB] text-[#0F172A] hover:bg-[#F8F9FA]",
    ghost: "text-[#475569] hover:bg-[#F1F5F9]",
    danger: "bg-red-50 text-red-700 border border-red-200 hover:bg-red-100",
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}

export const inr = (n) =>
  "₹ " + (Number(n) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
